import React from "react";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Checkbox
} from "@mui/material";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from '@mui/icons-material/Delete';
import { PiMicrosoftExcelLogoBold } from "react-icons/pi";
import {
  estadosOpciones,
  estadoMap,
  estadoDocumentalMap,
  estadoTelefonicaMap,
  DomicilioLaboralMap,
} from "./ListadoSolicitud.constants";

export function FiltrosListado({
  fechaInicio, setFechaInicio,
  fechaFin, setFechaFin,
  userData,
  selectedBodega, setSelectedBodega, bodegas,
  selectedVendedor, setSelectedVendedor, vendedores,
  analistaSelected, setAnalistaSelected, analistas,
  operadorSelected, setOperadorSelected, operadores,
  estado, setEstado,
  solicitud, setSolicitud,
  documental, setDocumental,
  telefonica, setTelefonica,
  domicilio, setDomicilio,
  laboral, setLaboral,
  cedula, setCedula,
  nombre, setNombre,
  numeroSolicitud, setNumeroSolicitud,
  motivoContinuidad, setMotivoContinuidad,
  handleConsultar, loadingConsulta, limpiarFiltros,
  puedeCrearSolicitud, handleSolictud,
  puedeCrearSolicitudNueva, handleNuevaSolicitud,
  imprimirInforme, setOpenModalExcel,
  crearYupana, handleSolictudYupana
}) {
  return (
    <>
      <div className="flex flex-col md:flex-row gap-4 md:gap-6 mb-4">
        <TextField
          label="Fecha Desde"
          type="date"
          variant="outlined"
          value={fechaInicio}
          onChange={(e) => { const fechaIniFiltro = e.target.value; setFechaInicio(fechaIniFiltro); sessionStorage.setItem('filtroIniFecha', fechaIniFiltro); }}
          fullWidth
          size="small"
          slotProps={{
            inputLabel: { shrink: true },
            input: {
              min: userData?.FechaIngreso
                ? new Date(userData.FechaIngreso).toISOString().split('T')[0]
                : undefined,
            },
          }}
        />
        <TextField
          label="Fecha Hasta"
          type="date"
          variant="outlined"
          value={fechaFin}
          onChange={(e) => { const fechaFinFiltro = e.target.value; setFechaFin(fechaFinFiltro); sessionStorage.setItem('filtroFinFecha', fechaFinFiltro); }}
          fullWidth
          size="small"
          InputLabelProps={{ shrink: true }}
        />
        <FormControl size="small" fullWidth>
          <InputLabel>Buscar por bodega</InputLabel>
          <Select
            value={selectedBodega}
            onChange={(e) => { const bodegaFiltro = e.target.value; setSelectedBodega(bodegaFiltro); sessionStorage.setItem('filtroBodega', bodegaFiltro); }}
            label="Buscar por nombre"
            disabled={userData?.idGrupo === 23}
          >
            <MenuItem value="todos">Todos</MenuItem>
            {bodegas.map((bodega) => (
              <MenuItem key={bodega.b_Bodega} value={bodega.b_Bodega}>
                {bodega.b_Nombre}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small" fullWidth>
          <InputLabel>Buscar por Vendedor</InputLabel>
          <Select
            value={selectedVendedor}
            onChange={(e) => { const vendedorFiltro = e.target.value; setSelectedVendedor(vendedorFiltro); sessionStorage.setItem('filtroVendedor', vendedorFiltro); }}
            label="Buscar por nombre"
            disabled={userData?.idGrupo === 23}
          >
            {userData?.idGrupo !== 23 && (<MenuItem value="todos">Todos</MenuItem>)}
            {(userData?.idGrupo === 23 ? vendedores.filter(
              (vendedor) => vendedor?.Codigo === userData?.Nombre)
              : vendedores
            ).map((vendedor) => (
              <MenuItem key={vendedor.idPersonal} value={vendedor.idPersonal}>
                {`${vendedor.Nombre || ""}`.trim() || "No disponible"}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" fullWidth>
          <InputLabel>Analista</InputLabel>
          <Select
            value={analistaSelected}
            onChange={(e) => { const analistaFiltro = e.target.value; setAnalistaSelected(analistaFiltro); sessionStorage.setItem('filtroAnalista', analistaFiltro); }}
            label="Analista"
          >
            <MenuItem value="todos">Todos</MenuItem>
            {analistas.map((vendedor) => (
              <MenuItem key={vendedor.idUsuario} value={vendedor.idUsuario}>
                {vendedor.Nombre?.trim() || "No disponible"}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" fullWidth>
          <InputLabel>Operadores</InputLabel>
          <Select
            value={operadorSelected}
            onChange={(e) => { const operadorFiltro = e.target.value; setOperadorSelected(operadorFiltro); sessionStorage.setItem('filtroOperador', operadorFiltro); }}
            label="Operadores"
          >
            <MenuItem value="todos">Todos</MenuItem>
            {operadores.map((operador) => (
              <MenuItem key={operador.idUsuario} value={operador.idUsuario}>
                {operador.Nombre?.trim() || "No disponible"}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" fullWidth>
          <InputLabel>Estado</InputLabel>
          <Select
            value={estado}
            onChange={(e) => { const estadoFiltro = e.target.value; setEstado(estadoFiltro); sessionStorage.setItem('filtroEstado', estadoFiltro); }}
            label="Estado"
          >
            {estadosOpciones.map((estado) => (
              <MenuItem key={estado.value} value={estado.value}>
                {estado.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <div className="flex flex-col md:flex-row gap-4 md:gap-6 mb-4">
        <FormControl size="small" fullWidth>
          <InputLabel>Solicitud</InputLabel>
          <Select
            value={solicitud}
            onChange={(e) => { const solicitudFiltro = e.target.value; setSolicitud(solicitudFiltro); sessionStorage.setItem('filtroSolicitud', solicitudFiltro); }}
            label="Solicitud"
          >
            <MenuItem value="Todos">Todos</MenuItem>
            {Object.entries(estadoMap).map(([key, label]) => (
              <MenuItem key={key} value={key}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small" fullWidth>
          <InputLabel>Documental</InputLabel>
          <Select
            value={documental}
            onChange={(e) => { const documentalFiltro = e.target.value; setDocumental(documentalFiltro); sessionStorage.setItem('filtroDocumental', documentalFiltro); }}
            label="Documental"
          >
            <MenuItem value="Todos">Todos</MenuItem>
            {Object.entries(estadoDocumentalMap).map(([key, label]) => (
              <MenuItem key={key} value={key}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small" fullWidth>
          <InputLabel>Telefonica</InputLabel>
          <Select
            value={telefonica}
            onChange={(e) => { const telefonicaFiltro = e.target.value; setTelefonica(telefonicaFiltro); sessionStorage.setItem('filtroTelefonica', telefonicaFiltro); }}
            label="Telefonica"
          >
            <MenuItem value="Todos">Todos</MenuItem>
            {Object.entries(estadoTelefonicaMap).map(([key, label]) => (
              <MenuItem key={key} value={key}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small" fullWidth>
          <InputLabel>Domicilio</InputLabel>
          <Select
            value={domicilio}
            onChange={(e) => { const domicilioFiltro = e.target.value; setDomicilio(domicilioFiltro); sessionStorage.setItem('filtroDomicilio', domicilioFiltro); }}
            label="Domicilio"
          >
            <MenuItem value="Todos">Todos</MenuItem>
            {Object.entries(DomicilioLaboralMap).map(([key, label]) => (
              <MenuItem key={key} value={key}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small" fullWidth>
          <InputLabel>Laboral</InputLabel>
          <Select
            value={laboral}
            onChange={(e) => { const LaboralFiltro = e.target.value; setLaboral(LaboralFiltro); sessionStorage.setItem('filtroLaboral', LaboralFiltro); }}
            label="Laboral"
          >
            <MenuItem value="Todos">Todos</MenuItem>
            {Object.entries(DomicilioLaboralMap).map(([key, label]) => (
              <MenuItem key={key} value={key}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      <div className="flex flex-col md:flex-row gap-4 md:gap-6 mb-4">
        <TextField
          label="Buscar por cédula"
          variant="outlined"
          value={cedula}
          onChange={(e) => { const cedulaFiltro = e.target.value; setCedula(cedulaFiltro); sessionStorage.setItem('filtroCedula', cedulaFiltro); }}
          fullWidth
          size="small"
          InputLabelProps={{ shrink: true }}
          InputProps={{ endAdornment: <IconButton></IconButton> }}
        />
        <TextField
          label="Buscar por nombre cliente"
          variant="outlined"
          value={nombre}
          onChange={(e) => { const nombreFiltro = e.target.value; setNombre(nombreFiltro); sessionStorage.setItem('filtroNombre', nombreFiltro); }}
          fullWidth
          size="small"
          InputLabelProps={{ shrink: true }}
          InputProps={{ endAdornment: <IconButton></IconButton> }}
        />
        <TextField
          label="Buscar por número de solicitud"
          variant="outlined"
          value={numeroSolicitud}
          onChange={(e) => { const numSoliFiltro = e.target.value; setNumeroSolicitud(numSoliFiltro); sessionStorage.setItem('filtroNumSolicitud', numSoliFiltro); }}
          fullWidth
          size="small"
          InputLabelProps={{ shrink: true }}
          InputProps={{ endAdornment: <IconButton></IconButton> }}
        />
      </div>

      <div className="flex flex-col md:flex-row gap-4 md:gap-6 mb-4">
        <div className="flex items-center gap-3 bg-gray-50 border border-gray-200 rounded-xl px-4 py-2 shadow-sm hover:shadow-md transition">
          <AssignmentTurnedInIcon className={`${motivoContinuidad ? "text-pink-800" : "text-gray-400"}`} />
          <label className="flex items-center gap-2 cursor-pointer text-sm font-medium text-gray-700">
            <Checkbox
              checked={motivoContinuidad}
              onChange={(e) => {
                const value = e.target.checked;
                setMotivoContinuidad(value);
                sessionStorage.setItem('filtroMotivoContinuidad', value);
              }}
              size="small"
              color="primary"
            />
            <span>Pendiente por Gestionar</span>
          </label>
        </div>
      </div>

      <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-6 mb-4">
        <button
          className="group relative flex items-center justify-center gap-2.5 px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 active:translate-y-0 disabled:opacity-70 disabled:cursor-not-allowed disabled:transform-none min-w-[140px]"
          onClick={handleConsultar}
          disabled={loadingConsulta}
        >
          {loadingConsulta ? (
            <>
              <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span>Consultando...</span>
            </>
          ) : (
            <>
              <SearchIcon className="text-xl group-hover:scale-110 transition-transform duration-300" />
              <span>Consultar</span>
            </>
          )}
        </button>
        <button
          className="group relative flex items-center gap-2.5 px-6 py-3 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 active:translate-y-0"
          onClick={limpiarFiltros}
        >
          <DeleteIcon className="text-xl group-hover:rotate-12 transition-transform duration-300" />
          <span>Limpiar</span>
        </button>

        {puedeCrearSolicitud && puedeCrearSolicitud() && (
          <button
            title="Nueva Solicitud"
            className="group relative flex items-center gap-2.5 px-6 py-3 bg-gradient-to-r from-indigo-600 to-indigo-700 hover:from-indigo-700 hover:to-indigo-800 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 active:translate-y-0 overflow-hidden"
            onClick={handleSolictud}
          >
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-0 group-hover:opacity-20 group-hover:animate-shimmer"></div>
            <span className="relative z-10">Nueva Solicitud</span>
          </button>
        )}
        
        {puedeCrearSolicitudNueva && puedeCrearSolicitudNueva() && (
          <button
            title="Nueva Solicitud "
            className="group relative flex items-center gap-2.5 px-6 py-3 bg-gradient-to-r from-fuchsia-600 to-fuchsia-700 hover:from-fuchsia-700 hover:to-fuchsia-800 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 active:translate-y-0 overflow-hidden"
            onClick={handleNuevaSolicitud}
          >
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-0 group-hover:opacity-20 group-hover:animate-shimmer"></div>
            <span className="relative z-10">Nueva Solicitud</span>
          </button>
        )}

        {imprimirInforme && imprimirInforme() && (
          <button
            className="group relative flex items-center gap-2.5 px-6 py-3 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 active:translate-y-0"
            onClick={() => setOpenModalExcel(true)}
          >
            <PiMicrosoftExcelLogoBold size={22} className="group-hover:scale-110 transition-transform duration-300" />
            <span>Crear Informe</span>
          </button>
        )}

        {crearYupana && crearYupana() && (
          <button
            className="group relative flex items-center gap-2.5 px-6 py-3 bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5 active:translate-y-0"
            onClick={handleSolictudYupana}
          >
            <img src="/img/yupana.jpeg" alt="Yupana" className="h-6 w-auto object-contain rounded" />
          </button>
        )}
      </div>
    </>
  );
}
